import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useMediaQuery } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import DrawerComponent from './Drawer';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { useTheme } from '@mui/material/styles';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
// redux
import { useSelector, useDispatch } from 'react-redux';
import LogoutIcon from '@mui/icons-material/Logout';
import { isRepManager, isAdmin } from '@util/helper';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import UpcomingOutlinedIcon from '@mui/icons-material/UpcomingOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import HailOutlinedIcon from '@mui/icons-material/HailOutlined';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import ChairAltOutlinedIcon from '@mui/icons-material/ChairAltOutlined';
// import logo from '@images/logo-tns.png'
import logo from '@images/logo_white.png'
import Avatar from '@mui/material/Avatar';
import useStyles from '@hooks/useStyles'
import LeftDrawer from '@components/LeftDrawer';
import { GlobalStyle as gs } from '@src/GlobalStyle'
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import WebService from '@util/webService';
const mainColor = '#33c058'

const drawerWidth = 240;
const CHAT_PATH_RE = /\/chat$/

const useChatUnread = (sideMenu, schoolId, account) => {
  const location = useLocation()
  const [count, set_count] = React.useState(0)
  const chatTo = sideMenu?.find(m => m.visible && CHAT_PATH_RE.test(m.to ?? ''))?.to
  // 관리자는 서버에서 항상 0이므로 조회하지 않음
  const enabled = !!chatTo && !!schoolId && !!account?.user?.id && !isAdmin(account)
  const lectureYn = chatTo?.startsWith('/teacher/') ? 'Y' : 'N'

  const load = React.useCallback(async () => {
    if(!enabled) {
      set_count(0)
      return
    }
    try {
      const resp = await WebService.get(`/chat/unread/school/${schoolId}`, { lectureYn })
      if(resp.repCode !== 'ack') return
      set_count(Number(JSON.parse(resp.repMessage).unreadRootCount) || 0)
    }
    catch(e) {
      console.log('Failed to load unread chat count', e)
    }
  }, [enabled, schoolId, lectureYn])

  React.useEffect(() => {
    load()
  }, [load, location.key])

  React.useEffect(() => {
      if(!enabled) return
      window.addEventListener('chat-unread-refresh', load)
      return () => {
        window.removeEventListener('chat-unread-refresh', load)
      }
    }, [enabled, load])

  return { chatTo, unread: count }
}

export default function CommonDrawer({sideMenu, title, barBgColor, sideBgColor, menuIdx}) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)
  const { chatTo, unread } = useChatUnread(sideMenu, schola?.id, account)
  const [activeMenu, set_activeMenu] = React.useState({})
  const [activeIdx, set_activeIdx] = React.useState( menuIdx ?? 1)

  const defIcon = <LabelOutlinedIcon size='small' sx={{color:'#212121'}}/>
  const defSx = {color:'#212121', fontSize:20}
  const primaryTypographyProps = (index) => {
    return {
      style: {
        fontSize:14,
        fontFamily: ['JejuGothic', 'sans-serif'],
        color: activeIdx === index ? theme.palette.primary.main : '#212121',
        fontWeight:activeIdx === index ? 'bold' : 'normal'
      }

    }
  }


  const styledIcon = (menu, index, activeIdx) => {
    const icon = menu.icon ? menu.icon : defIcon
    const newIcon = React.cloneElement(icon, {
      style: {
        ...icon.props.style,
        color: index === activeIdx ? theme.palette.primary.main : '#212121'
      }
    })

    return (
      newIcon
    )
  }



  return (
    <Box sx={{ display: 'flex',}}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: barBgColor ?? theme.palette.primary.bar }} elevation={0}>
        <Toolbar sx={{ backgroundColor:barBgColor ?? theme.palette.primary.bar}}>
          <div style={{flex:0.5, display:'flex', justifyContent:'flex-start' }}>
            {
              isMobile && sideMenu ? (
                <LeftDrawer sideMenu={sideMenu}/>
              ) :  null

            }
            <Link to='/welcome' className={classes.logo} style={{display:'flex', justifyContent:'center', alignItems:'center', }}>
              <img src={logo} alt='logo' style={{width: isMobile ? 20 : 25, marginRight:10, }} />
              {
                isMobile ? null :(
                  <Typography noWrap className={classes.logo} sx={{fontSize:18}} component={Link} to='/welcome' >
                    스쿨매니저
                  </Typography>
                )
              }
            </Link>
          </div>

          <Typography noWrap component="div" className={classes.schoolName} style={{textAlign:'center', fontWeight:'bold', flex:1,}}>
            {title ?? ''}
          </Typography>
          {
            account?.user?.id ? (
              isMobile ? (
                <div style={{display:'flex', flex:0.5, justifyContent:'flex-end' }}>
                  <DrawerComponent />
                </div>
              ) : (
                <div style={{flex:0.5, display:'flex', justifyContent:'flex-end'}}>
                  <div className={classes.logo}></div>
                  <div className={classes.navlinks}>
                    {
                      account?.user?.name? (
                        <Link to="#" className={classes.userName} >
                          {account.user.name}님
                        </Link>
                      ) : null
                    }

                    <Link to="/profile" className={classes.link} >
                       설정
                    </Link>
                    <Link to="/logout" className={classes.link} sx={{display:'flex', alignItems:'center'}} >
                      <LogoutIcon size='small' sx={{fontSize:20}}/>
                    </Link>
                  </div>
                </div>
              )
            ) : <div style={{flex:0.5,}} />
          }
        </Toolbar>
      </AppBar>
      {
        sideMenu ? (
          isMobile ? (
            null
          ) : (
            <Drawer
              variant="permanent"
              sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', backgroundColor: sideBgColor ?? null},
              }}
            >
              <Box sx={{ overflow: 'auto', mt:theme.spacing(7), }}>
                <List>
                  {
                    sideMenu && sideMenu.map((menu, index) => (
                      menu.visible ? (
                        menu.text === 'divider' ? (
                          <Divider key={index}/>
                        ) : (
                          <ListItem key={index} disablePadding component={Link} to={menu.to} onClick={()=> {set_activeIdx(index)}}
                                style={{justifyContent:'center', alignItems:'center'}}
                          >
                            <ListItemButton selected={index === activeIdx} >
                              <ListItemIcon sx={{minWidth:'35px', color: index === activeIdx ? 'red' : 'black' }}>
                                    {styledIcon(menu, index, activeIdx)}
                              </ListItemIcon>
                              <ListItemText
                                  primaryTypographyProps={primaryTypographyProps(index)}
                                  primary={menu.text}
                                />
                                {
                                  menu.to === chatTo && unread > 0 ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', color: '#b71c1c' }}>
                                      <NotificationsNoneOutlinedIcon sx={{ fontSize: 18 }} />
                                      <Typography sx={{ fontSize: 13, fontWeight: 'bold', ml: 0.5 }}>{unread}</Typography>
                                    </Box>
                                  ) : null
                                }
                            </ListItemButton>
                          </ListItem>
                        )
                      ) : null
                    ))
                  }
                </List>
              </Box>
            </Drawer>
          )
        ): null
      }
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
